/**
 * A default set of media queries to use for different screen sizes. Based on
 * the breakpoints defined by design. These are different than the typical
 * shared styles media queries and should generally be considered for use only
 * on external marketing pages.
 *
 * Use like:
 *   StyleSheet.create({
 *       blah: {
 *           [mediaQueries.smallPhone]: {
 *
 *           };
 *       };
 *   });
 */

export const smallPhoneMax = "359px";
export const phoneMin = "360px";
export const phoneMax = "374px";
export const largePhoneMin = "375px";
export const largePhoneMax = "566px";
export const smallTabletMin = "567px";
export const smallTabletMax = "767px";
export const tabletMin = "768px";
export const tabletMax = "834px";
export const smallDesktopMin = "835px";
export const smallDesktopMax = "1023px";
export const desktopMin = "1024px";
export const desktopMax = "1199px";
export const largeDesktopMin = "1200px";
export const largeDesktopMax = "1299px";
export const xlDesktopMin = "1300px";

export const shortPhoneMaxHeight = "660px";
export const tallPhoneMinHeight = "661px";
export const veryTallMinHeight = "940px";

export const smallPhoneOnly = `@media screen and (max-width: ${smallPhoneMax})`;
export const phoneOnly: string =
    `@media screen and (min-width: ${phoneMin}) and ` +
    `(max-width: ${phoneMax})`;
export const largePhoneOnly: string =
    `@media screen and (min-width: ${largePhoneMin}) and ` +
    `(max-width: ${largePhoneMax})`;
export const tallPhoneOnly: string =
    `@media screen and (max-width: ${largePhoneMax}) and ` +
    `(min-height: ${tallPhoneMinHeight})`;
export const shortPhoneOnly: string =
    `@media screen and (max-width: ${largePhoneMax}) and ` +
    `(max-height: ${shortPhoneMaxHeight})`;
export const smallTabletOnly: string =
    `@media screen and (min-width: ${smallTabletMin}) and ` +
    `(max-width: ${smallTabletMax})`;
export const tabletOnly: string =
    `@media screen and (min-width: ${tabletMin}) and ` +
    `(max-width: ${tabletMax})`;
export const smallDesktopOnly: string =
    `@media screen and (min-width: ${smallDesktopMin}) and ` +
    `(max-width: ${smallDesktopMax})`;
export const desktopOnly: string =
    `@media screen and (min-width: ${desktopMin}) and ` +
    `(max-width: ${desktopMax})`;
export const largeDesktopOnly: string =
    `@media screen and (min-width: ${largeDesktopMin}) and ` +
    `(max-width: ${largeDesktopMax})`;
export const xlDesktopOnly = `@media screen and (min-width: ${xlDesktopMin})`;

export const shortAndDesktopOrWider: string =
    `@media screen and (min-width: ${desktopMin}) and ` +
    `(max-height: ${shortPhoneMaxHeight})`;
export const veryTallAndDesktopOrWider: string =
    `@media screen and (min-width: ${desktopMin}) and ` +
    `(min-height: ${veryTallMinHeight})`;

export const smallPhoneOrSmaller = `@media screen and (max-width: ${smallPhoneMax})`;
export const phoneOrSmaller = `@media screen and (max-width: ${phoneMax})`;
export const largePhoneOrSmaller = `@media screen and (max-width: ${largePhoneMax})`;
export const smallTabletOrSmaller = `@media screen and (max-width: ${smallTabletMax})`;
export const tabletOrSmaller = `@media screen and (max-width: ${tabletMax})`;
export const smallDesktopOrSmaller = `@media screen and (max-width: ${smallDesktopMax})`;
export const desktopOrSmaller = `@media screen and (max-width: ${desktopMax})`;
export const largeDesktopOrSmaller = `@media screen and (max-width: ${largeDesktopMax})`;

export const phoneOrLarger = `@media screen and (min-width: ${phoneMin})`;
export const largePhoneOrLarger = `@media screen and (min-width: ${largePhoneMin})`;
export const smallTabletOrLarger = `@media screen and (min-width: ${smallTabletMin})`;
export const tabletOrLarger = `@media screen and (min-width: ${tabletMin})`;
export const smallDesktopOrLarger = `@media screen and (min-width: ${smallDesktopMin})`;
export const desktopOrLarger = `@media screen and (min-width: ${desktopMin})`;
export const largeDesktopOrLarger = `@media screen and (min-width: ${largeDesktopMin})`;
export const xlDesktopOrLarger = `@media screen and (min-width: ${xlDesktopMin})`;
